import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const quagPowergridDuo: IProductData = {
  id: "quag-powergrid-duo",
  name: "Quagliardi Powergrid duo",
  description: "Horizontal 2 Slot 500 series chassis.",
  images: ["/img/quag_powergrid_duo_front.jpg", "/img/quag_powergrid_duo_back.jpg"],
  details: [{
    label: "Description",
    markdown: `
The POWERGRIDDUO is a horizontal 500 Series chassis designed to house and provide stable power to two modules.

The POWERGRIDDUO boasts two recessed slots, supports all standard 500 Series modules, and delivers up to 300mA of current per voltage rail.
It has a flexible routing provided by the POWERGRIDDUO’s rear-panel Stereo Link switch, and its per-slot Ground Lift switches make short work of any irritating hum that dares rear its ugly head.

Are you searching for a seamless way to integrate your 500 Series modules with your other rackmount gear? If so, you’ll be duly impressed by the look and performance of the POWERGRIDDUO.

- 2-slot horizontal 500 Series chassis fits seamlessly into a typical 1U rack space
- Houses and provides stable power to 2 modules
- Recessed slots accommodate all standard 500 Series modules
- Delivers up to 300mA of current per voltage rail
- Rear-panel Stereo Link switch provides flexible routing
- Per-slot Ground Lift switches eliminate 60-cycle hum
`
  }, {
    label: "Specifications",
    markdown: `
- Voltages: +/-16VDC and +48VDC for phantom power
- Max Current: 2000mA total on +/-16VDC rails and 250mA on +48VDC
- Input Voltage: 100-240VAC, 50/60Hz, 120 Watts
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://quagliardiaudio.com/500-series-chassis/" target="_blank">https://quagliardiaudio.com/500-series-chassis/</a>
- <a to="https://drive.google.com/file/d/1srzQN7M1jcbYRmBsaPmi8drkhfcisZbX/view" target="_blank">Manual</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.CASES, HASHTAGS.RECORDING, HASHTAGS.MASTERING, HASHTAGS.MIXING, HASHTAGS.ONE_U],
    manufacturer: BRAND.QUAGLIARDI,
  }
}